import { Cookies } from 'react-cookie';

import { ClientFormValuesWithObject } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const createClientWithObject = async ({
  client,
  isObjectCreating,
}: {
  client: ClientFormValuesWithObject;
  isObjectCreating: boolean;
}) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const payload: any = {
    name: client.name,
    EDRPOU: client.EDRPOU,
    business_structure: client.business_structure,
    country: client.country,
    city: client.city,
    zip_code: client.zip_code || '',
    street: client.street,
    building_no: client.building_no,
    apartment_no: client.apartment_no,
    full_name: client.full_name || '',
    owner: client.owner || null,
    technician: client.technician || null,
  };

  const data = await axiosInterceptor.post('/clients/create-client-with-object/', payload, {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
    params: {
      isObjectCreating,
    },
  });

  return data.data as any;
};
